<template>
  <div class="fade-in">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div>
          <h1 class="title mb2">Trends</h1>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-half-desktop is-full-mobile is-half-tablet mb1">
        <div class="card pointer" @click="selector('nuw')">
          <div class="card-content columns is-mobile is-multiline">
            <div class="column is-narrow is-pulled-left">
              <i class="fa fa-circle status status-nuw"></i>
            </div>
            <div class="column is-pulled-left">
              <h2>{{ nuw }} New Patients</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-half-desktop is-full-mobile is-half-tablet mb1">
        <div class="card pointer" @click="selector('scheduled')">
          <div class="card-content columns is-mobile is-multiline">
            <div class="column is-narrow is-pulled-left">
              <i class="fa fa-circle status status-scheduled"></i>
            </div>
            <div class="column is-pulled-left">
              <h2>{{ scheduled }} Scheduled</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="subtitle">{{ selectedTitle }} volume over time</h2>
    <div class="chart">
      <chart :chartData="data"></chart>
    </div>

    <div class="pull-right select mt2">
      <select v-model="dayOfWeek">
        <option value="-1">All</option>
        <option v-for="(day, index) in week" :value="index">{{ day }}</option>
      </select>
    </div>
    <h2 class="subtitle mt2">Popular Times</h2>

    <div class="popular-times">
      <popular-times
        v-if="!popularTimesLoading"
        :chartData="times"
      ></popular-times>
      <div v-if="popularTimesLoading">
        <i class="fa fa-refresh fa-spin"></i>
      </div>
    </div>

    <h2 class="subtitle mt2">Export Daily Data</h2>
    <form>
      <div class="mv1 demo">
        <div class="label">Download for date:</div>
        <!---->
        <div>
          <div class="columns">
            <div class="column">
              <datetime
                v-model="dailyReport.startDate"
                :auto="true"
                :autoDate="false"
                zone="UTC"
                valueZone="UTC"
                :format="dailyReport.config.format"
              ></datetime>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="pull-right">
        <i
          v-if="!dailyReport.downloading"
          class="fa fa-download hover has-text-grey-light pointer"
          title="Download detailed report"
          @click="downloadDailyReport"
        ></i>
        <i
          v-if="dailyReport.downloading"
          class="fa fa-refresh fa-spin has-text-grey-light"
        ></i>
      </div>
    </form>

    <h2 class="subtitle mt2">Export Monthly Data</h2>

    <table class="table is-striped is-fullwidth mv2">
      <thead>
        <tr>
          <th width="40%">Date</th>
          <th>{{ selectedTitle }}</th>
          <th>
            <i
              class="fa fa-file-excel-o hover has-text-grey-light pointer"
              title="Download month report"
              @click="monthReport()"
              v-if="!report.loading"
            ></i>
            <i
              class="fa fa-refresh fa-spin has-text-grey-light"
              v-if="report.loading"
            ></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="stat in stats" class="data-row">
          <td>{{ stat["month"] }}</td>
          <td>{{ stat["count"] }}</td>
          <td class="has-text-left">
            <span v-if="stat['count'] < 3000">
              <i
                v-if="!showLoading(stat['month'])"
                class="fa fa-file-excel-o hover has-text-grey-light pointer"
                title="Download detailed report"
                @click="detailedReport(stat['month'])"
              ></i>
              <i
                class="fa fa-refresh fa-spin has-text-grey-light"
                v-if="showLoading(stat['month'])"
              ></i>
            </span>
            <span v-else>Data set is too large download monthly report.</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="panel-body" v-if="report.url">
      <iframe :src="report.url" frameborder="0" scrolling="no"></iframe>
    </div>
    <div class="panel-body" v-if="dailyReport.url">
      <iframe :src="dailyReport.url" frameborder="0" scrolling="no"></iframe>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import TrendsService from "@/services/TrendsService";
import chart from "./chart";
import popularTimes from "./PopularTimes";
import { DateTime } from "luxon";

export default {
  name: "trends",

  components: {
    chart,
    popularTimes
  },

  data() {
    return {
      loading: true,
      selected: "nuw",
      dailyReport: {
        downloading: false,
        startDate: null,
        config: {
          format: DateTime.DATE_FULL
        }
      },
      data: {
        labels: [],
        datasets: [
          {
            backgroundColor: "#ecf5fe",
            borderColor: "#469df6",
            data: [],
            pointRadius: 6,
            pointBorderColor: "#469df6",
            pointBackgroundColor: "#fff"
          }
        ]
      },
      times: {
        labels: [
          "0a",
          "1a",
          "2a",
          "3a",
          "4a",
          "5a",
          "6a",
          "7a",
          "8a",
          "9a",
          "10a",
          "11a",
          "12p",
          "1p",
          "2p",
          "3p",
          "4p",
          "5p",
          "6p",
          "7p",
          "8p",
          "9p",
          "10p",
          "11p"
        ],
        datasets: [
          {
            backgroundColor: "#ecf5fe",
            borderColor: "#469df6",
            data: []
          }
        ]
      },
      popularTimesLoading: true,
      week: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      dayOfWeek: -1,
      report: {
        loading: false,
        detailed: null,
        url: null
      }
    };
  },

  watch: {
    dayOfWeek(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updatePopularTimes();
      }
    }
  },

  computed: {
    nuw() {
      return this.$store.getters["trend/newTotal"];
    },
    scheduled() {
      return this.$store.getters["trend/scheduledTotal"];
    },
    stats() {
      const colors = {
        nuw: {
          line: "rgba(65, 155, 249, 1)",
          fill: "rgba(65, 155, 249, 0.4)"
        },
        scheduled: {
          line: "rgba(117, 226, 31, 1)",
          fill: "rgba(117, 226, 31, 0.4)"
        }
      };
      const stats = this.$store.getters["trend/newScheduled"][this.selected];
      const newData = _.cloneDeep(this.data);
      newData.labels = stats.map(stat => stat.month);
      newData.datasets[0].data = stats.map(stat => stat.count);
      newData.datasets[0].borderColor = colors[this.selected].line;
      newData.datasets[0].pointBorderColor = colors[this.selected].line;
      newData.datasets[0].backgroundColor = colors[this.selected].fill;
      this.data = newData;
      return stats;
    },
    selectedTitle() {
      return this.selected === "nuw" ? "New" : "Scheduled";
    }
  },

  methods: {
    selector(stat) {
      this.selected = stat;
      this.toggleSelector();
    },
    toggleSelector() {
      this.showSelector = !this.showSelector;
    },
    monthReport() {
      this.report.loading = true;
      TrendsService.monthReport().then(data => {
        this.report.loading = false;
        this.report.url = data.url;
      });
    },
    detailedReport(month) {
      this.report.detailed = month;
      TrendsService.detailedReport(month)
        .then(data => {
          this.report.loading = false;
          this.report.url = data.url;
          this.report.detailed = null;
        })
        .catch(_ => {
          this.report.loading = false;
        });
    },
    downloadDailyReport() {
      if (this.dailyReport.startDate) {
        this.dailyReport.downloading = true;
        TrendsService.downloadDailyReport(this.dailyReport.startDate)
          .then(data => {
            this.dailyReport.downloading = false;
            this.dailyReport.url = data.url;
          })
          .catch(_ => {
            this.dailyReport.downloading = false;
          });
      }
    },
    showLoading(month) {
      return this.report.detailed === month;
    },
    updatePopularTimes() {
      this.popularTimesLoading = true;
      TrendsService.getPopularTimes(0, this.dayOfWeek).then(() => {
        const data = this.$store.getters["trend/popularTimes"];
        const newTimes = _.cloneDeep(this.times);
        newTimes.datasets[0].data = data;
        this.times = newTimes;
        this.popularTimesLoading = false;
      });
    }
  },

  mounted() {
    TrendsService.get();
    this.updatePopularTimes();
  }
};
</script>

<style lang="scss" scoped>
.chart,
.popular-times {
  height: 450px;
  background: #fff;
  padding: 1rem;
}
</style>
